import { TwitterNewsType } from '@pff-consumer/schema'

export const newsEndpoints = {
  latestTweets: ({ type }: { type?: TwitterNewsType }) => {
    return { url: `/football/v1/nfl/news/latest-tweets${type ? `?type=${type}` : ''}` }
  },
}
